// src/translations/nav.js
export default {
  en: {
    home: "Home",
    sell_property: "Hai una proprietà da vendere?"
  },
  it: {
    home: "Home",
    sell_property: "Hai una proprietà da vendere?"
  }
};